module.exports = __webpack_public_path__ + "img/liucheng1.b18f6241.png";